module.exports = __webpack_public_path__ + "img/landing-in.405535ba.svg";